import { HTMLAttributes } from 'react';
import cn from 'classnames';

import css from './Spinner.module.css';

export type SpinnerProps = Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export const Spinner = ({ className, ...restProps }: SpinnerProps) => {
  return <div {...restProps} className={cn(css.spinner, className)} />;
};
